<template>
    <TopCard v-if="posts" :method="setSong" :post="posts[0]"/>
    <GridDisplay title="Resultados" :method="setSong" :posts="posts"/>
</template>

<script>
import TopCard from '@/components/TopCard.vue';
import GridDisplay from '@/components/GridDisplay.vue';
export default {
  components: { TopCard, GridDisplay },
  name: 'RecientesView',
  data(){
    return{
      posts: [],
    }
  },
  mounted(){
    const url='https://rev-proxy-foxbel.herokuapp.com/chart?index=0&limit=14';
    fetch(url)
      .then(response=>response.json())
      .then(json=>this.posts = json.tracks.data);
  },
  methods:{
    setSong(a){
      if(typeof a !== 'undefined'){
        const parse = JSON.stringify(a)
        localStorage.setItem('currentSong', parse);
      }
    }
  }
}
</script>